<div
  class="fixed inset-0 w-screen h-screen bg-black/60 flex items-center justify-center z-[1000]"
  tabindex="-1"
  (keydown.esc)="closeModal(); $event.preventDefault(); $event.stopPropagation();"
>
  <div
    class="bg-[#2a2b2e] rounded-[24px] shadow-[0_12px_48px_rgba(0,0,0,0.32)] px-4 pt-6 pb-16 max-w-[800px] w-[90vw] min-w-[90vw] relative text-white font-sans md:px-10 md:pt-10 md:pb-20 md:min-w-[400px]"
  >
    <button
      class="absolute top-4 right-4 text-gray-300 hover:text-white bg-none rounded-full p-2"
      (click)="closeModal()"
      aria-label="Cerrar"
    >
      <mat-icon style="font-size: 22px">highlight_off</mat-icon>
    </button>
    <h1 class="text-5xl font-bold text-white">
      Búsqueda <span class="italic font-light">Global</span>
    </h1>
    <div class="mt-6 w-full flex flex-row gap-2 items-center">
      <app-input-search
        #searchInput
        class="flex-1 min-w-0 italic font-light"
        placeholder="Buscar usuarios, grupos o aplicaciones..."
        (searchClick)="onSearch($event)"
        (searchInput)="onSearchInput($event)"
      ></app-input-search>
    </div>

    <!-- Active Filter Badge/Chip and Search Term Badge -->
    @if (currentFilter || searchTerm) {
    <div
      class="mt-3 flex items-center gap-2 flex-wrap"
    >
      <span class="text-xs text-gray-400">
        @if (currentFilter && searchTerm) {
          Filtrando por:
        } @else if (currentFilter && !searchTerm) {
          Filtrando por:
        } @else if (!currentFilter && searchTerm) {
          Buscando:
        }
      </span>

      <!-- Filter Type Chip - Solo aparece cuando hay un filtro específico seleccionado -->
      @if (currentFilter) {
      <div
        class="inline-flex items-center gap-2 px-2.5 py-1 rounded-full text-xs font-medium bg-neutral-800 text-white border border-white transition-all duration-200 animate-[slideIn_0.3s_ease-out]"
      >
        <mat-icon style="font-size: 14px; width: 14px; height: 14px">
          {{ getFilterIcon(currentFilter) }}
        </mat-icon>
        <span>{{ getFilterLabel(currentFilter) }}</span>
        <button
          (click)="clearFilter()"
          class="ml-0.5 flex items-center justify-center hover:bg-white/20 hover:scale-110 rounded-full p-0.5 transition-all border-none bg-transparent cursor-pointer text-inherit"
          aria-label="Limpiar filtro"
          type="button"
        >
          <mat-icon
            style="font-size: 12px; width: 12px; height: 12px; line-height: 1"
            >close</mat-icon
          >
        </button>
      </div>
      }

      <!-- Search Term Chip - Muestra el término de búsqueda -->
      @if (searchTerm) {
      <div
        class="inline-flex items-center gap-2 px-2.5 py-1 rounded-full text-xs font-medium bg-neutral-800 text-white border border-white transition-all duration-200 animate-[slideIn_0.3s_ease-out]"
      >
        <mat-icon style="font-size: 14px; width: 14px; height: 14px">
          search
        </mat-icon>
        <span>"{{ searchTerm }}"</span>
        <button
          (click)="clearSearchTerm()"
          class="ml-0.5 flex items-center justify-center hover:bg-white/20 hover:scale-110 rounded-full p-0.5 transition-all border-none bg-transparent cursor-pointer text-inherit"
          aria-label="Limpiar búsqueda"
          type="button"
        >
          <mat-icon
            style="font-size: 12px; width: 12px; height: 12px; line-height: 1"
            >close</mat-icon
          >
        </button>
      </div>
      }
    </div>
    }

    <!-- Filters -->
    <div class="flex flex-wrap gap-2 mt-4">
      <button
        class="flex items-center gap-2 px-4 py-2 rounded-md text-sm border transition-all duration-300"
        [ngClass]="{
          'bg-[#1e1d1f] pl-[18px] relative text-[#8a38f5] border-[#8a38f580] shadow-[0_0_6px_rgba(162,17,229,0.363)] before:content-[\'\'] before:absolute before:left-[6px] before:top-2 before:bottom-2 before:w-1 before:rounded before:bg-[#8a38f5]':
            currentFilter === modalType.USER,
          'bg-[#2d2d30] border-white/30 text-white hover:bg-[#444448]':
            currentFilter !== modalType.USER,
        }"
        (click)="setFilter(modalType.USER)"
      >
        <mat-icon style="font-size: 18px">person</mat-icon> Usuario
      </button>
      <button
        class="flex items-center gap-2 px-4 py-2 rounded-md text-sm border transition-all duration-300"
        [ngClass]="{
          'bg-[#1e1d1f] pl-[18px] relative text-[#ff0090] border-[#ff009080] shadow-[0_0_6px_rgba(229,17,190,0.363)] before:content-[\'\'] before:absolute before:left-[6px] before:top-2 before:bottom-2 before:w-1 before:rounded before:bg-[#ff0090]':
            currentFilter === modalType.TEAM,
          'bg-[#2d2d30] border-white/30 text-white hover:bg-[#444448]':
            currentFilter !== modalType.TEAM,
        }"
        (click)="setFilter(modalType.TEAM)"
      >
        <mat-icon style="font-size: 18px">people</mat-icon> Grupo
      </button>
      <button
        class="flex items-center gap-2 px-4 py-2 rounded-md text-sm border transition-all duration-300"
        [ngClass]="{
          'bg-[#1e1d1f] pl-[18px] relative text-[#38dcf5] border-[#38dcf580] shadow-[0_0_6px_rgba(17,208,229,0.363)] before:content-[\'\'] before:absolute before:left-[6px] before:top-2 before:bottom-2 before:w-1 before:rounded before:bg-[#38dcf5]':
            currentFilter === modalType.APP,
          'bg-[#2d2d30] border-white/30 text-white hover:bg-[#444448]':
            currentFilter !== modalType.APP,
        }"
        (click)="setFilter(modalType.APP)"
      >
        <mat-icon style="font-size: 18px">memory</mat-icon> Aplicación
      </button>
    </div>

    <div
      #resultsContainer
      class="mt-6 mb-20 bg-[#232326] border-none rounded-2xl p-4 h-[300px] overflow-y-auto [scrollbar-width:thin] [scrollbar-color:#444_#232326] [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar]:bg-transparent [&::-webkit-scrollbar]:rounded-lg [&::-webkit-scrollbar-thumb]:bg-[#444] [&::-webkit-scrollbar-thumb]:rounded-lg [&::-webkit-scrollbar-thumb:hover]:bg-[#666] [&::-webkit-scrollbar-button]:hidden"
    >
      <!-- Loading state -->
      @if (isLoading) {
      <div
        class="flex flex-col items-center justify-center h-full text-gray-400"
      >
        <div
          class="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-400 mb-4"
        ></div>
        <p class="text-lg font-medium">Buscando...</p>
      </div>
      }

      <!-- Idle state (Before Search) -->
      @if (!isLoading && !searchTerm) {
      <div
        class="flex flex-col items-center justify-center h-full text-gray-500 opacity-40"
      >
        <mat-icon
          style="
            font-size: 64px;
            width: 64px;
            height: 64px;
            margin-bottom: 1rem;
          "
          >search</mat-icon
        >
        <p class="text-lg font-medium">¿Qué deseas buscar?</p>
        <p class="text-sm">
          Escribe para encontrar usuarios, grupos o apps
        </p>
      </div>
      }

      <!-- Empty state message -->
      @if (!isLoading && results.length === 0 && searchTerm) {
      <div
        class="flex flex-col items-center justify-center h-full text-gray-400"
      >
        <mat-icon
          style="
            font-size: 64px;
            width: 64px;
            height: 64px;
            margin-bottom: 1rem;
            opacity: 0.5;
          "
          >inbox</mat-icon
        >
        <p class="text-lg font-medium">No se encontraron resultados</p>
        <p class="text-sm mt-2">Intenta con otros términos de búsqueda</p>
      </div>
      }

      <!-- Results list -->
      @for (result of results; track result; let i = $index) {
        <div
          #resultItem
          class="flex items-center gap-3 px-3 py-2 mt-1 cursor-pointer min-h-[48px] rounded-xl transition-colors border border-transparent hover:border-orange-400 focus:outline-none focus:ring-2 focus:ring-orange-400"
          [ngClass]="{
            'bg-[#6a3e00] text-white': selectedIndex === i,
            'bg-[#232326] text-white': selectedIndex !== i,
          }"
          [attr.data-index]="i"
          tabindex="0"
          role="button"
          (click)="selectResult(result)"
          (keydown.enter)="selectResult(result)"
          (keydown.space)="selectResult(result)"
        >
          <!-- Avatar/Ícono -->
          <div
            class="w-10 h-10 flex items-center justify-center rounded-full font-bold text-lg"
            [ngClass]="{
              'bg-orange-900': result.type === 'Usuario',
              'bg-blue-900': result.type === 'Equipo',
              'bg-green-900': result.type === 'Rol',
              'bg-purple-900': result.type === 'Aplicación',
            }"
          >
            @switch (result.type) {
              @case ('Usuario') {
                <mat-icon>person</mat-icon>
              }
              @case ('Equipo') {
                <mat-icon>people</mat-icon>
              }
              @case ('Rol') {
                <mat-icon>tag_faces</mat-icon>
              }
              @case ('Aplicación') {
                <mat-icon>memory</mat-icon>
              }
              @default {
                <span>{{
                  result.name ? result.name.charAt(0) : "?"
                }}</span>
              }
            }
          </div>
          <!-- Info -->
          <div class="flex flex-col min-w-0">
            <div class="flex items-center gap-2">
              @if (result.type) {
                <span
                  class="font-bold text-xs uppercase tracking-wide"
                  [ngClass]="{
                    'text-orange-400': result.type === 'Usuario',
                    'text-blue-400': result.type === 'Grupo',
                    'text-purple-400': result.type === 'Aplicación',
                  }"
                  >{{ result.type }}</span
                >
              }
              <span class="text-base font-semibold truncate">{{
                result.name
              }}</span>
            </div>
            <span
              class="text-xs leading-4 truncate"
              [ngClass]="result.color || 'text-gray-300'"
              >{{ result.desc }}</span
            >
          </div>
        </div>
      }
      @if (
        currentFilter === 'team' &&
        results.length > 0
      ) {
      <div
        class="text-xs text-gray-300 mt-2 text-right pr-2"
      >
        Total de
        grupos encontrados:
        {{ results.length }}
      </div>
      }
    </div>

    <!-- Footer controls (fixed at bottom) -->
    <div
      class="absolute bottom-0 left-0 right-0 flex justify-between items-center px-4 py-2 bg-[#2a2b2e] rounded-b-[24px] border-t border-white/10 text-xs gap-2"
    >
      <div class="flex items-center gap-1 text-gray-300">
        <kbd
          class="min-w-[18px] h-[18px] px-1 bg-[#2d2d30] border border-white/20 rounded text-[10px] font-semibold text-[#e0e0e0] text-center shadow-sm [font-family:'Courier_New',monospace]"
          >Enter</kbd
        >
        <span>Seleccionar</span>
      </div>
      <div class="flex items-center gap-1 text-gray-300">
        <mat-icon
          class="min-w-[18px] h-[18px] px-1 bg-[#2d2d30] border border-white/20 rounded text-[10px] font-semibold text-[#e0e0e0] text-center shadow-sm"
          style="font-size: 13px"
          >arrow_upward</mat-icon
        >
        <mat-icon
          class="min-w-[18px] h-[18px] px-1 bg-[#2d2d30] border border-white/20 rounded text-[10px] font-semibold text-[#e0e0e0] text-center shadow-sm"
          style="font-size: 13px"
          >arrow_downward</mat-icon
        >
        <span>Navegar</span>
      </div>
      <div class="flex items-center gap-1 text-gray-300">
        <kbd
          class="min-w-[18px] h-[18px] px-1 bg-[#2d2d30] border border-white/20 rounded text-[10px] font-semibold text-[#e0e0e0] text-center shadow-sm [font-family:'Courier_New',monospace]"
          >Esc</kbd
        >
        <span>Salir</span>
      </div>
    </div>
  </div>
</div>
